import { useDemoMode } from "../../context/DemoModeContext";
import DemoBlockedMessage from "./DemoBlockedMessage";

export function DemoGateConnexion({ children }) {
  const { isDemoSession, demoClientEnabled } = useDemoMode();
  if (isDemoSession && !demoClientEnabled) {
    return (
      <DemoBlockedMessage title="Connexion">
        La connexion compte client est désactivée pendant la démonstration.
      </DemoBlockedMessage>
    );
  }
  return children;
}

export function DemoGateInscription({ children }) {
  const { isDemoSession } = useDemoMode();
  if (isDemoSession) {
    return (
      <DemoBlockedMessage title="Inscription">
        La création de compte est désactivée pendant la démonstration.
      </DemoBlockedMessage>
    );
  }
  return children;
}

export function DemoGateForgotPassword({ children }) {
  const { isDemoSession } = useDemoMode();
  if (isDemoSession) {
    return (
      <DemoBlockedMessage title="Mot de passe oublié">
        La réinitialisation de mot de passe est désactivée en démonstration.
      </DemoBlockedMessage>
    );
  }
  return children;
}

export function DemoGateResetPassword({ children }) {
  const { isDemoSession } = useDemoMode();
  if (isDemoSession) {
    return (
      <DemoBlockedMessage title="Réinitialisation">
        Cette étape n&apos;est pas disponible en démonstration.
      </DemoBlockedMessage>
    );
  }
  return children;
}

export function DemoGateAccount({ children }) {
  const { isDemoSession, demoClientEnabled } = useDemoMode();
  if (isDemoSession && !demoClientEnabled) {
    return (
      <DemoBlockedMessage title="Espace client">
        L&apos;espace personnel est masqué pendant la présentation. Utilisez le catalogue et le panier pour
        vous projeter.
      </DemoBlockedMessage>
    );
  }
  return children;
}

export function DemoGatePayment({ children }) {
  const { isDemoSession } = useDemoMode();
  if (isDemoSession) {
    return (
      <DemoBlockedMessage title="Paiement">
        Le tunnel de paiement est désactivé en démonstration. Les commandes réelles ne peuvent pas être
        finalisées depuis cet environnement.
      </DemoBlockedMessage>
    );
  }
  return children;
}
